import initialState from '../../../redux/initialState';
import {
  reverseGeocode,
  fetchCart as getCart,
  removeCartFromStorage,
  removeCartItemsFromState,
  changeCartProperty,
  updateCartFromLocaleStorage,
  addNewItemToCart,
  placeInmotions} from '../../../logic/api';
import {geocode} from '../../../logic/utils';
import { formatCartRes } from '../../../logic/formatCartRes';
import _ from 'lodash';
import {isAuthenticated} from '../../../logic/authHelpers';
import {removePartnerToCart} from '../../../components/ToCartPopup/redux/toCartPopupActions';
import { onFetchUserInmotionsCount} from '../../../components/User/redux/userInmotionAction';


export const pay = () => ({
  type: 'CART:PAYOUT-FINISHED'
});

export const geocodeSelfPickupAddress = () => (dispatch, getState) => {
  dispatch({
    type: 'CART:SELFPICKUP-ADDRESS-GEOCODE-REQUEST-SENT'
  });

  geocode({ //todo refactor and move it somewhere
    city: getState().cartReducer.address
  }, (res) => {
    if (!res || !res[0]) {
      return dispatch(onGeocodeSelfPickupAddressFail());
    }
    dispatch(onGeocodeSelfPickupAddressSuccess({
      lat: res[0].geometry.location.lat(),
      lng: res[0].geometry.location.lng()
    }));
    if (_.isEmpty(getState().cartReducer.latLng)) {
      dispatch({
        type: 'CART:SHIPPING-POS-INIT',
        latLng: {
          lat: res[0].geometry.location.lat(),
          lng: res[0].geometry.location.lng()
        }
      });
    }
  });
};

export function fetchCart() {
  return (dispatch) => {
    dispatch({
      type: 'CART:FETCH-REQUEST-SENT'
    });
    updateCartFromLocaleStorage();
    getCart()
      .then((res) => dispatch(onCartFetchSuccess(res)))
      .catch((err) => dispatch(onCartFetchFail(err)));
  };
}

const onCartFetchSuccess = (res) => ({
  type: 'CART:FETCH-REQUEST-SENT-SUCCESS',
  cartItems: formatCartRes(res)
});

const onCartFetchFail = (err) => ({
  type: 'CART:FETCH-REQUEST-SENT-FAIL',
  err
});

const onGeocodeSelfPickupAddressFail = (err) => ({
  type: 'CART:SELFPICKUP-ADDRESS-GEOCODE-REQUEST-FAIL',
  err
});

const onGeocodeSelfPickupAddressSuccess = (selfPickupLatLng) => ({
  type: 'CART:SELFPICKUP-ADDRESS-GEOCODE-REQUEST-SUCCESS',
  selfPickupLatLng
});

export const switchShippingMethod = (shippingMethod) => ({
  type: 'CART:CHANGE-SHIPPING-METHOD',
  shippingMethod
});

export function removeItem(e) {
    return (dispatch, getState) => {
        dispatch({
            type: 'CART:ITEM-REMOVE'
        });

        let cartItemId = e.currentTarget.getAttribute('data-cartdetailid');
        let cartItems = getState().cartReducer.cartItems;

        removeCartFromStorage(cartItemId)
            .then(() => {
              if(!isAuthenticated() && +cartItems.length == 1) {
                 dispatch(removePartnerToCart());


              }
              dispatch(onCartRemoveSuccess(cartItemId, cartItems));
              dispatch(fetchCart());
            })
            .catch((err) =>  dispatch(onCartRemoveFail(err)));
    };
}

const onCartRemoveSuccess = (cartItemId, cartItems) => ({
    type: 'CART:ITEM-REMOVE-SENT-SUCCESS',
    cartItems: removeCartItemsFromState(cartItemId, cartItems)
});

const onCartRemoveFail = (err) => ({
    type: 'CART:ITEM-REMOVE-SENT-FAIL',
    err
});

export const changeItemComment = (CartDetailId, {text}) =>
    (dispatch, getState) => {
      dispatch({
          type: 'CART:COMMENT-CHANGE'
      });

      let cartItems = getState().cartReducer.cartItems;

      changeCartProperty({ text }, CartDetailId, cartItems)
          .then(
          (res) => {
              if (res.error) {
                  return dispatch(onCartChangeCommentError(res.error));
              }
              dispatch(onCartChangeCommentSuccess(text, CartDetailId));
          })
          .catch((err) => dispatch(onCartChangeCommentError(err)));

  };

const onCartChangeCommentSuccess = (CartDetailId, {text}) => ({
    type: 'CART:CHANGE-ITEM-COMMENT-SUCCESS',
    CartDetailId,
    text
});

const onCartChangeCommentError = (err) => ({
    type: 'CART:CHANGE-ITEM-COMMENT-ERR',
    err
});


export const changeCartItemQuantity = (newQuantity, cartDetailId) =>
    (dispatch, getState) => {
        dispatch({
            type: 'CART:CHANGE-ITEM-QUANTITY'
        });

        let cartItems = getState().cartReducer.cartItems;
        changeCartProperty({ newQuantity }, cartDetailId, cartItems)
            .then(
            (res) => {
                if (res.error) {
                    return dispatch(onCartChangeQuantityError(res.error));
                }
                dispatch(onCartChangeQuantitySuccess(newQuantity, cartDetailId));
            })
            .catch((err) => dispatch(onCartChangeQuantityError(err)));
    };

const onCartChangeQuantitySuccess = (newQuantity, cartDetailId) => ({
    type: 'CART:CHANGE-ITEM-QUANTITY-SUCCESS',
    newQuantity,
    cartDetailId
});

const onCartChangeQuantityError = (err) => ({
    type: 'CART:CHANGE-ITEM-QUANTITY-ERR',
    err
});

export const handleMapClick = ({latLng}) => (dispatch) => {
  dispatch({
    type: 'CART:REVERSE-GEOCODE-REQUEST-SENT',
    latLng: {
      lat: latLng.lat(),
      lng: latLng.lng()
    }
  });
  return reverseGeocode({
    lat: latLng.lat(),
    lon: latLng.lng()
  }).then((res) => dispatch(res.error ?
    onReverseGeocodeFail(res.error)
    : onReverseGeocodeSuccess(res)))
  .catch((err) => dispatch(onReverseGeocodeFail(err)));
};

export const onReverseGeocodeSuccess = ({address}) => ({
  type: 'CART:REVERSE-GEOCODE-REQUEST-SUCCESS',
  address
});

export const onReverseGeocodeFail = (err) => ({
  type: 'CART:REVERSE-GEOCODE-REQUEST-FAIL',
  err: err
});

const debouncedGeocodeAddress = _.debounce((address, getState, dispatch) => {
  geocode(address, (res) => {
    if (!res || !res[0]) {
      return dispatch(onGeocodeFail());
    }
    dispatch(onGeocodeSuccess({
      lat: res[0].geometry.location.lat(),
      lng: res[0].geometry.location.lng()
    }));
  });
}, 500);

export const onAddressInputChange = ({target}) => (dispatch, getState) => {
  dispatch({
    type: 'CART:ADDRESS-CHANGE-MANUALLY',
    payload: {
      [target.name]: target.value
    }
  });

  debouncedGeocodeAddress({
    ...getState().cartReducer.shippingAddress,
    [target.name]: target.value
  }, getState, dispatch);
};

const onGeocodeSuccess = (latLng) => ({
  type: 'CART:GEOCODE-REQUEST-SUCCESS',
  latLng
});

const onGeocodeFail = (err) => ({
  type: 'CART:GEOCODE-REQUEST-FAIL',
  err
});

export const onAddNewItemToCart = (newCartDetailItem) => (dispatch) => {
  dispatch({
    type: 'CART:ADD-NEW-ITEM'
  });

  const {cartDetailId, comment, detailNum, name, offerId, price, quantity, supplier} = newCartDetailItem;

  let cartDetail = {
    CartDetailId: cartDetailId,
    Comment: comment,
    Name: name,
    Description: 'description', //TODO: Get description from db ?
    DetailNum: detailNum,
    Quantity: quantity,
    Price: price,
    OfferId: offerId,
    Supplier: {SupplierId: supplier.supplierId, SupplierName: supplier.supplierName, Rating: supplier.rating, DeliveryTerms: supplier.deliveryTerms }};

  addNewItemToCart(cartDetail)
    .then(() => dispatch(onAddNewItemToCartSuccess(cartDetail)))
    .catch((err) => dispatch(onAddNewItemToCartFail(err)));
};

export const onAddNewItemToCartSuccess = (cartDetail) => ({
  type: 'CART:ADD-NEW-ITEM-SUCCESS',
  cartDetail
});

export const onAddNewItemToCartFail = (err) => ({
  type: 'CART:ADD-NEW-ITEM-FAIL',
  err: err
});

/**
 * Inmotions
 */
export const onPlaceInmotions = () => dispatch => {
  dispatch({
    type: 'CART:REQUEST-PLACE-INMOTIONS'
  });

  placeInmotions()
    .then((res) => {
      if(res.error)
        dispatch(onPlaceInmotionsFail());
      else {
        dispatch(onPlaceInmotionsSuccess());
        dispatch(onFetchUserInmotionsCount());
      }
    })
    .catch((err) => dispatch(onPlaceInmotionsFail(err)));
};

const onPlaceInmotionsSuccess = () => ({
  type: 'CART:REQUEST-PLACE-INMOTIONS-SUCCESS'
});

const onPlaceInmotionsFail = (error) => ({
  type: 'CART:REQUEST-PLACE-INMOTIONS-FAIL',
  error
});

/**
 *
 */

export default function cartReducer(state = initialState.cartState, action) {
  switch(action.type) {
    case 'CART:CHANGE-SHIPPING-METHOD':
      return {
        ...state,
        selectedShippingMethod: action.shippingMethod
      };

    case 'CART:REVERSE-GEOCODE-REQUEST-SENT':
      return {
        ...state,
        latLng: action.latLng,
        isShowingMapBalloon: true
      };

    case 'CART:REVERSE-GEOCODE-REQUEST-FAIL':
      return {
        ...state,
        mapErr: action.err
      };

    case 'CART:REVERSE-GEOCODE-REQUEST-SUCCESS':
      return {
        ...state,
        shippingAddress: action.address
      };

    case 'CART:CHANGE-ITEM-QUANTITY-SUCCESS': {
      const index = _.findIndex(state.cartItems, { CartDetailId: action.cartDetailId });
      return {
        ...state,
        cartItems: [
          ...state.cartItems.slice(0, index),
          {
            ...state.cartItems[index],
            Quantity: action.newQuantity
          },
          ...state.cartItems.slice(index + 1)
        ]
      };
    }

    case 'CART:ADDRESS-CHANGE-MANUALLY':
      return {
        ...state,
        shippingAddress: {
          ...state.shippingAddress,
          ...action.payload
        }
      };

    case 'CART:GEOCODE-REQUEST-SUCCESS':
      return {...state, latLng: action.latLng};

    case 'CART:GEOCODE-REQUEST-FAIL':
      return {...state, mapErr: action.err};

    case 'CART:COMMENT-CHANGE-SUCCESS':
      return {
        ...state,
        cartItems:  _.reduce(state.cartItems, (res, el) => {
          if (el.CartDetailId === action.CartDetailId) {
            return [
              ...res,
              {
                ...el,
                Comment: action.text
              }
            ];
          }
          return [...res, el];
      }, [])};

    case 'CART:ITEM-REMOVE-SENT-SUCCESS':
      return {
        ...state,
        cartItems: action.cartItems
      };

    case 'CART:SELFPICKUP-ADDRESS-GEOCODE-REQUEST-SUCCESS':
      return {
        ...state,
        selfPickupLatLng: action.selfPickupLatLng
      };

    case 'CART:SHIPPING-POS-INIT':
      return {
        ...state,
        latLng: action.latLng
      };

    case 'CART:FETCH-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        cartItems: action.cartItems
      };
    case 'CART:ADD-NEW-ITEM-SUCCESS':
      return {
        ...state,
        cartItems: [...state.cartItems, action.cartDetail]
      };
    case 'CART:REQUEST-PLACE-INMOTIONS-SUCCESS':
      return {
        ...state,
        cartItems: []
      };
    case 'CART:REQUEST-PLACE-INMOTIONS-FAIL':
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CartPage/redux/cartPageActions.js
 **/